/* eslint-disable brace-style */
import React from 'react';
import PropTypes from 'prop-types';
import {Drawer} from 'antd';
import {ReactComponent as Hamburger} from '../../assets/img/hamburger.svg';
import {ReactComponent as BrandMobileWhite} from '../../assets/img/brandMobileWhite.svg';
import {ReactComponent as Close} from '../../assets/img/close.svg';
import {ReactComponent as ArrowLeft} from '../../assets/img/arrowLeft.svg';
import {connect} from 'react-redux';
import {isLoggedIn} from '../../redux/selectors/auth';
import TranslatedText from '../TranslatedText';
import {DASHBOARD_PAGE, FAQ_PAGE, INDEX_PAGE, PROFILE_PAGE, WORKERS_PAGE} from '../../configuration/paths';
import {makeAction} from '../../redux/actions/makeAction';
import {LOG_OUT, OPEN_MODAL} from '../../redux/actions/actionTypes';
import {withRouter} from 'react-router';

const MobileDrawer = ({loggedIn, openModal, logout, history}) => {
  const [opened, setOpened] = React.useState(false);
  return (
    <React.Fragment>
      <Hamburger onClick={() => setOpened(!opened)}/>
      <Drawer
        title={
          <div className="mobile-drawer-title">
            <BrandMobileWhite/>
            <Close onClick={() => setOpened(!opened)}/>
          </div>
        }
        closable={false}
        placement="left"
        onClose={() => setOpened(!opened)}
        visible={opened}
        width={375}
        className="mobile-drawer"
      >
        <ul>
          {
            loggedIn && <React.Fragment>
              <li onClick={() => {setOpened(!opened); history.push(DASHBOARD_PAGE);}}>
                <span><TranslatedText transKey="navigation.pages.dashboard"/></span>
                <ArrowLeft/>
              </li>
              <li onClick={() => {setOpened(!opened); history.push(WORKERS_PAGE);}}>
                <span><TranslatedText transKey="navigation.pages.miners"/></span>
                <ArrowLeft/>
              </li>
              <li onClick={() => {setOpened(!opened); history.push(PROFILE_PAGE);}}>
                <span><TranslatedText transKey="navigation.pages.profile"/></span>
                <ArrowLeft/>
              </li>
            </React.Fragment>
          }
          <li onClick={() => {setOpened(!opened); history.push(INDEX_PAGE);}}>
            <span><TranslatedText transKey="navigation.pages.about"/></span>
            <ArrowLeft/>
          </li>
          <li onClick={() => {setOpened(!opened); history.push(FAQ_PAGE);}}>
            <span><TranslatedText transKey="navigation.pages.faq"/></span>
            <ArrowLeft/>
          </li>
          {
          }
        </ul>
      </Drawer>
    </React.Fragment>
  );
};

MobileDrawer.propTypes = {
  loggedIn: PropTypes.bool.isRequired,
  logout: PropTypes.func.isRequired,
  openModal: PropTypes.func.isRequired,
  history: PropTypes.shape({
    push: PropTypes.func.isRequired,
  }).isRequired,
};

const mapStateToProps = state => ({
  loggedIn: isLoggedIn(state),
});

const mapDispatchToProps = {
  logout: makeAction(LOG_OUT),
  openModal: makeAction(OPEN_MODAL),
};

export default withRouter(connect(
  mapStateToProps,
  mapDispatchToProps,
)(React.memo(MobileDrawer)));



// WEBPACK FOOTER //
// /src/components/navigation/MobileDrawer.jsx